import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Logo from './Logo';

var API_URL = process.env.REACT_APP_BACKEND_URL;

function LinkItem({ slug, name }) {
  return (
    <Link to={"/solutions/" + slug} className="block text-gray-300 hover:text-[#81bce3] text-xs transition-colors">
      {name}
    </Link>
  );
}

export default function MegaFooter() {
  var linksState = useState(null);
  var links = linksState[0];
  var setLinks = linksState[1];

  useEffect(function() {
    fetch(API_URL + '/api/seo/footer-links')
      .then(function(r) { return r.json(); })
      .then(function(data) { setLinks(data); })
      .catch(function(e) { console.error('Footer links error:', e); });
  }, []);

  var sLinks = links ? links.stakeholder_links : [
    { name: "Dealer Loyalty", slug: "dealer-loyalty-program" },
    { name: "Distributor Loyalty", slug: "distributor-loyalty-program" },
    { name: "Retailer Loyalty", slug: "retailer-loyalty-program" },
    { name: "Influencer Loyalty", slug: "influencer-loyalty-program" },
    { name: "Painter Loyalty", slug: "painter-loyalty-program" },
    { name: "Plumber Loyalty", slug: "plumber-loyalty-program" },
  ];
  var iLinks = links ? links.industry_links : [
    { name: "Cement Loyalty", slug: "cement-dealer-loyalty-program" },
    { name: "Paints Loyalty", slug: "paints-dealer-loyalty-program" },
    { name: "Steel Loyalty", slug: "steel-dealer-loyalty-program" },
    { name: "FMCG", slug: "fmcg-dealer-loyalty-program" },
    { name: "Pharma", slug: "pharma-dealer-loyalty-program" },
    { name: "Auto Parts", slug: "auto-parts-dealer-loyalty-program" },
  ];
  var pLinks = links ? (links.program_links || []) : [];
  var rLinks = links ? (links.reward_links || []) : [];
  var gLinks = links ? (links.geo_links || []) : [];

  var kLinks = [
    { name: "Channel Loyalty Program", slug: "channel-loyalty-program" },
    { name: "B2B Loyalty Platform", slug: "b2b-loyalty-platform" },
    { name: "WhatsApp Loyalty Platform", slug: "whatsapp-loyalty-platform" },
    { name: "Learn & Earn Platform", slug: "learn-and-earn-platform" },
    { name: "Gamified LMS", slug: "gamified-lms" },
    { name: "AI LMS", slug: "ai-lms" },
  ];

  // Pre-render link lists to avoid nested maps in JSX
  var stakeholderItems = sLinks.map(function(l) { return <LinkItem key={l.slug} slug={l.slug} name={l.name} />; });
  var industryItems = iLinks.map(function(l) { return <LinkItem key={l.slug} slug={l.slug} name={l.name} />; });
  var programItems = pLinks.map(function(l) { return <LinkItem key={l.slug} slug={l.slug} name={l.name} />; });
  var rewardItems = rLinks.map(function(l) { return <LinkItem key={l.slug} slug={l.slug} name={l.name} />; });
  var geoItems = gLinks.map(function(l) { return <LinkItem key={l.slug} slug={l.slug} name={l.name} />; });
  var keywordItems = kLinks.map(function(l) { return <LinkItem key={l.slug} slug={l.slug} name={l.name} />; });

  return (
    <footer className="text-gray-200 pt-16 pb-8" style={{backgroundColor: '#3d4a6b'}} data-testid="mega-footer">
      <div className="container">
        
        {/* Brand + Nav */}
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-10 pb-8 border-b border-white/10">
          <div className="max-w-md">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Logo className="h-10" />
            </Link>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              The operating system for B2B channel loyalty, trade marketing, and partner incentive programs.
              Purpose-built for manufacturing enterprises.
            </p>
            <div className="flex gap-3 text-xs">
              <span className="bg-white/10 px-3 py-1 rounded-full text-gray-200">100+ Enterprise Clients</span>
              <span className="bg-white/10 px-3 py-1 rounded-full text-gray-200">5M+ Channel Partners</span>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-sm">
            <div>
              <div className="text-[#81bce3] font-semibold mb-3 text-xs uppercase tracking-wider">Platform</div>
              <div className="space-y-2">
                <Link to="/platform" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Architecture</Link>
                <Link to="/ai-brain" className="block text-gray-300 hover:text-[#81bce3] transition-colors">AI Brain</Link>
                <Link to="/rewards" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Rewards Catalog</Link>
                <Link to="/integrations" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Integrations</Link>
              </div>
            </div>
            <div>
              <div className="text-[#81bce3] font-semibold mb-3 text-xs uppercase tracking-wider">Company</div>
              <div className="space-y-2">
                <Link to="/solutions" className="block text-gray-300 hover:text-[#81bce3] transition-colors">All Solutions</Link>
                <Link to="/industries" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Industries</Link>
                <Link to="/case-studies" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Case Studies</Link>
                <Link to="/why-channelloyalty" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Why ChannelLoyalty</Link>
                <Link to="/contact" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Contact</Link>
              </div>
            </div>
            <div>
              <div className="text-[#81bce3] font-semibold mb-3 text-xs uppercase tracking-wider">Resources</div>
              <div className="space-y-2">
                <Link to="/blog" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Blog</Link>
                <Link to="/channel-loyalty-report-2026" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Industry Report</Link>
                <Link to="/glossary" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Glossary</Link>
                <Link to="/partners" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Partners</Link>
                <Link to="/press" className="block text-gray-300 hover:text-[#81bce3] transition-colors">Press</Link>
              </div>
            </div>
            <div>
              <div className="text-[#81bce3] font-semibold mb-3 text-xs uppercase tracking-wider">Contact</div>
              <div className="space-y-2 text-gray-300 text-xs">
                <div>Chandra Shekhar</div>
                <div>+91 9910059861</div>
                <div>+91 9811123206</div>
                <div>chandra@channelloyalty.ai</div>
                <a href="https://wa.me/919910059861" target="_blank" rel="noopener noreferrer" className="block text-[#8abb3b] hover:text-[#a3d152]">WhatsApp Us</a>
              </div>
            </div>
          </div>
        </div>

        {/* Curated SEO Links — 6 columns, max 6 per category */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 mb-8">
          <div>
            <h4 className="text-[#81bce3] text-xs font-bold uppercase tracking-wider mb-3">By Stakeholder</h4>
            <div className="space-y-1.5">{stakeholderItems}</div>
          </div>
          <div>
            <h4 className="text-[#81bce3] text-xs font-bold uppercase tracking-wider mb-3">By Industry</h4>
            <div className="space-y-1.5">{industryItems}</div>
          </div>
          {programItems.length > 0 && (
            <div>
              <h4 className="text-[#81bce3] text-xs font-bold uppercase tracking-wider mb-3">By Program</h4>
              <div className="space-y-1.5">{programItems}</div>
            </div>
          )}
          {rewardItems.length > 0 && (
            <div>
              <h4 className="text-[#81bce3] text-xs font-bold uppercase tracking-wider mb-3">By Reward</h4>
              <div className="space-y-1.5">{rewardItems}</div>
            </div>
          )}
          {geoItems.length > 0 && (
            <div>
              <h4 className="text-[#81bce3] text-xs font-bold uppercase tracking-wider mb-3">By Region</h4>
              <div className="space-y-1.5">{geoItems}</div>
            </div>
          )}
          <div>
            <h4 className="text-[#81bce3] text-xs font-bold uppercase tracking-wider mb-3">Popular Searches</h4>
            <div className="space-y-1.5">{keywordItems}</div>
          </div>
        </div>

        {/* View All Solutions CTA */}
        <div className="mb-8 pb-6 border-b border-white/10">
          <Link
            to="/solutions"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#8abb3b] hover:text-[#81bce3] transition-colors"
            data-testid="footer-view-all-solutions"
          >
            View All 500+ Loyalty Solutions
            <ArrowRight size={14} />
          </Link>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-gray-400 text-xs" data-testid="footer-copyright">
            A product of TagQuest Innovations Pvt Ltd. Copyright {new Date().getFullYear()} ChannelLoyalty. All rights reserved. India's leading B2B channel loyalty platform.
          </div>
          <div className="flex gap-4 text-xs text-gray-400">
            <Link to="/privacy-policy" className="hover:text-[#81bce3]">Privacy</Link>
            <Link to="/terms-of-use" className="hover:text-[#81bce3]">Terms</Link>
            <Link to="/cookie-policy" className="hover:text-[#81bce3]">Cookies</Link>
            <Link to="/security-compliance" className="hover:text-[#81bce3]">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
